import { render, staticRenderFns } from "./OutsideGroupQueryList.vue?vue&type=template&id=0fbcb0c7&scoped=true&"
import script from "./OutsideGroupQueryList.vue?vue&type=script&lang=js&"
export * from "./OutsideGroupQueryList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fbcb0c7",
  null
  
)

export default component.exports